import { Injectable } from '@angular/core';
import {UtilsService} from "./utils.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {HttpHeaders} from "@angular/common/http";
import * as _ from "lodash";

@Injectable()
export class SearchService {

  constructor(
    private httpClient: HttpClient,
    private utils: UtilsService
  ) { }


  query(term): Observable<any> {

    let request = _.cloneDeep(this.utils.algolia.request);
    request.params += term;
    let query = {requests:[request]};

    let httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.utils.algolia.url, query, {
      responseType: 'json',
      headers: httpHeaders
    });

  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/search.service.ts